module.exports = __webpack_public_path__ + "static/media/Fairytale_RewardBackground.530b0c9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/reward-background/Fairytale_RewardBackground.png
// module id = 1357
// module chunks = 3